"use client";

import React from "react";
import { Github, Instagram, Twitter, Terminal } from "lucide-react";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-8">
        {[1, 2, 3].map((_, i) => <div key={i} data-index={i} className="space-y-4">
            <div className="h-4 w-24 bg-muted/20 animate-pulse rounded-md" />
            <div className="h-4 w-32 bg-muted/20 animate-pulse rounded-md" />
            <div className="h-4 w-20 bg-muted/20 animate-pulse rounded-md" />
          </div>)}
      </div>;
  }
  return <NavigationMenu viewport={false} className="w-full max-w-none justify-start items-start">
      <NavigationMenuList className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-x-12 gap-y-4 w-full !items-start !justify-start flex-col sm:flex-row">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i} className="w-full list-none">
            <NavigationMenuLink asChild className="w-full justify-start hover:bg-transparent focus:bg-transparent data-[active=true]:bg-transparent px-0 py-1.5 text-muted-foreground hover:text-primary focus:text-primary transition-colors">
              <Link to={item.href || "#"} className="flex items-center gap-2 group">
                <span className="text-primary opacity-0 group-hover:opacity-100 transition-opacity duration-200 font-mono">
                  {">"}
                </span>
                <span className="group-hover:translate-x-1 transition-transform duration-200 font-default text-sm">
                  {item.label}
                </span>
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };
  const socials = [{
    name: "Twitter",
    icon: Twitter,
    href: "#"
  }, {
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }, {
    name: "Github",
    icon: Github,
    href: "#"
  }];
  return <section data-section-id="264819" id="footer" className="bg-background text-foreground font-default py-12 px-6 md:px-12 border-t border-border/50 relative overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none bg-[linear-gradient(transparent_50%,rgba(0,255,255,0.02)_50%)] bg-[length:100%_4px] opacity-20 z-0" />

      
    </section>;
}